export const UPDATE_EVENT_STATE = 'UPDATE_EVENT_STATE';
export const EVENTS_LOADING = 'EVENTS_LOADING';
export const EVENTS_LOADED = 'EVENTS_LOADED';
export const EVENTS_ERROR = 'EVENTS_ERROR';
export const UPDATE_EVENT_LOADING = 'UPDATE_EVENT_LOADING';
export const UPDATE_EVENT_LOADED = 'UPDATE_EVENT_LOADED';
export const EVENT_UPDATED = 'EVENT_UPDATED';
export const EVENT_CREATED = 'EVENT_CREATED';
export const EVENT_DELETED = 'EVENT_DELETED';
export const EVENT_HISTOGRAM_LOADING = 'EVENT_HISTOGRAM_LOADING';
export const EVENT_HISTOGRAM_LOAD_ERROR = 'EVENT_HISTOGRAM_LOAD_ERROR';
export const EVENT_HISTOGRAM_RECEIVED = 'EVENT_HISTOGRAM_RECEIVED';


// WEBPACK FOOTER //
// ./src/data/redux/event_details/actiontypes.js